import { ICourse } from '../types/course.types';

export const filterCourseById = (
  courses: ICourse[] = [],
  id: number,
): ICourse => courses.filter((course) => course.id === id)[0];
